










































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { Organization } from '@/common/Organizations';
import { User } from '@/common/Users';

// Tabs
import TabProfile from '@/components/Staff/UserManagement/Tabs/Profile.vue';
import TabAuditLog from '@/components/Staff/UserManagement/Tabs/Auditlog.vue';
import CallLog from '@/components/Staff/UserManagement/Tabs/CallLog.vue';
import TabPolicies from '@/components/Staff/UserManagement/Tabs/Policies.vue';
import TabPermissions from '@/components/Staff/UserManagement/Tabs/Permissions.vue';
import TabBilling from '@/components/Staff/UserManagement/Tabs/Billing.vue';

// Components
import Loading from '@/components/Global/Loading.vue';
import Alert from '@/components/Global/Alert.vue';
import Sidebar from '@/components/Staff/UserManagement/Sidebar.vue';
import Welcome from '@/components/Global/Welcome.vue';

import UserDetails from '@/components/Staff/UserManagement/UserDetails.vue';

// Services
import { Features } from '@/services/Features';
import Staff from '@/services/Staff';
import * as Sentry from '@sentry/browser';

// Validations
import { required, email } from 'vuelidate/lib/validators';

@Component({
	name: 'PageStaffUserManagementSingle',
	components: {
		TabProfile,
		TabAuditLog,
		CallLog,
		TabPolicies,
		TabPermissions,
		TabBilling,
		Loading,
		Alert,
		Sidebar,
		Welcome,
		UserDetails,
	},
	validations: {
		user: {
			org_id: {
				required,
			},
			email: {
				required,
				email,
			},
			phone_number: {
				required,
			},
		},
	},
})
export default class SingleUserManagement extends Vue {
	@State('user', { namespace: 'Users' }) private user: Partial<User> = undefined;

	private readonly Features = Features;

	private currentTab: string = 'profile';
	private isInvalid: boolean = false;
	private siteAccess: string[] = [];

	private userId: string = '';
	private error: boolean = false;
	private errMessage: string = '';
	private errorSave: boolean = false;
	private loading: boolean = true;
	private loadingSites: boolean = true;
	private success: boolean = false;
	private hasStaffError: boolean = false;

	@Watch('$route', { deep: true })
	private watchRoute(newValue) {
		this.currentTab = this.$route.params.tab;
	}

	@Watch('user', { deep: true })
	private watchUser() {
		if (this.user.brands !== undefined) {
			this.siteAccess = this.user.brands;
		}

		if (!this.user.preferences) {
			this.user.preferences = {};
		}
	}

	/**
	 * Switch Tabs
	 */
	private tab(tab) {
		this.currentTab = tab;

		this.$router.push({
			name: 'staffusermanagementsingle',
			params: {
				org_id: this.$route.params.org_id,
				tab,
			},
		});
	}

	/**
	 * Save the user data to the api
	 */
	private async saveUserData() {
		const user = this.user;
		this.isInvalid = false;
		this.error = false;
		this.errMessage = '';
		this.errorSave = false;
		this.success = false;
		this.hasStaffError = false;

		this.$v.$touch();

		if (this.$v.$invalid) {
			this.isInvalid = true;
			window.scrollTo(0, 0);
			return;
		}

		const getEmailAddressUrl = user.email.split('@');

		if (
			![
				'constellationmutual.com',
				'mmicgroup.com',
				'umia.com',
				'arkansasmutual.com',
			].includes(getEmailAddressUrl[1])
		) {
			let hasStaff = false;

			const userPermissions = user.permissions;

			Object.values(userPermissions).map((permissions, index) => {
				if (
					(permissions.STAFF !== undefined && permissions.STAFF === true) ||
					(permissions.STAFF_CLAIMS !== undefined && permissions.STAFF_CLAIMS === true) ||
					(permissions.STAFF_ACCOUNTING !== undefined &&
						permissions.STAFF_ACCOUNTING === true) ||
					(permissions.STAFF_SUPER !== undefined && permissions.STAFF_SUPER === true) ||
					(permissions.STAFF_DELETEUSER !== undefined &&
						permissions.STAFF_DELETEUSER === true)
				) {
					hasStaff = true;
				}
			});

			if (hasStaff) {
				this.hasStaffError = true;
				window.scrollTo(0, 0);
				return;
			}
		}

		// Set only data we need to send
		const sendData = {
			cmd: 'update' as const,
			user,
		};

		try {
			const updateData = await Staff.updateUser(sendData);
			this.success = true;
			window.scrollTo(0, 0);
		} catch (e) {
			Sentry.captureException(e);
			this.errorSave = true;
			this.success = false;
			window.scrollTo(0, 0);
		}
	}

	/**
	 * Get the user
	 */
	private async loadUser() {
		try {
			await this.$store.dispatch('Users/getUser', this.userId);
			await this.$store.dispatch('Organizations/getOrganizations');
		} catch (e) {
			Sentry.captureException(e);
			this.error = true;
			this.siteAccess = [];
			this.errMessage = e.data.msg; // getUser.data.msg;
		} finally {
			this.loading = false;
		}
	}

	private async created() {
		this.userId = this.$route.params.user_id;

		this.currentTab = this.$route.params.tab || 'profile';

		await this.loadUser();
	}
}
